/* ==========================================================
   GLIA EVENTS
   ========================================================== */

document.addEventListener("DOMContentLoaded", () => {

  
  document.querySelectorAll(".glia-event-card__toggle").forEach(button => {

    button.addEventListener("click", () => {

        const card = button.closest(".glia-event-card");

        card.classList.toggle("is-open");

        const open = card.classList.contains("is-open");

        button.setAttribute("aria-expanded", open);

        const label = button.querySelector(".glia-event-card__more");

        if (label) {

            label.textContent = open
                ? "Hide Details"
                : "Event Details";

        }

    });

});
});